export const DASHBOARD_CARD_SIZES = [
  { text: "Small", value: "SMALL" },
  { text: "Medium", value: "MEDIUM" },
  { text: "Large", value: "LARGE" },
];

export const DASHBOARD_WIDGET_SIZES = [
  { text: "S", value: "SMALL" },
  { text: "M", value: "MEDIUM" },
  { text: "L", value: "LARGE" },
  { text: "XL", value: "FULL" },
];

export const DASHBOARD_LAYOUTS = [
  { text: "Row", value: "ROW" },
  { text: "Grid", value: "GRID" },
];
